import styled from "styled-components"

import { Box, Flex, Picture } from "components/common"
import { jewlr_t } from "helpers/application"
import {
  LinkBlock,
  SectionDescription,
  SectionLink,
  SectionTextBlock,
  SectionTitle,
} from "jewlr/pages/components"

const Block = styled(Box).attrs((props) => ({
  display: "block",
  flex: "1",
  ...props,
}))``

const BestSellers = () => (
  <Flex display={{ _: "block", tablet: "flex" }} gutter={{ tablet: 2 }}>
    <Block>
      <LinkBlock data-lc="best-sellers" to="/best-sellers-for-her">
        <Picture
          fallback={`${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/best-sellers-for-her/desktop_2x.jpg`}
          srcSet={[
            {
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: `
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/best-sellers-for-her/mobile.jpg 767w,
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/best-sellers-for-her/mobile_2x.jpg 1534w
              `,
            },
            {
              media: "(min-width: 768px)",
              sizes: "100vw",
              srcSet: `
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/best-sellers-for-her/desktop.jpg 590w,
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/best-sellers-for-her/desktop_2x.jpg 1180w
              `,
            },
          ]}
        />
      </LinkBlock>
      <SectionTextBlock>
        <SectionTitle>Best Sellers For Her</SectionTitle>
        <SectionDescription>
          Our most popular {jewlr_t("terms.personalized")} styles.
        </SectionDescription>
        <SectionLink data-lc="best-sellers" to="/best-sellers-for-her">
          Shop Now
        </SectionLink>
      </SectionTextBlock>
    </Block>
    <Block>
      <LinkBlock data-lc="best-sellers" to="/new-items-for-her">
        <Picture
          fallback={`${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/whats-new-for-her/desktop_2x.jpg`}
          srcSet={[
            {
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: `
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/whats-new-for-her/mobile.jpg 767w,
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/whats-new-for-her/mobile_2x.jpg 1534w
              `,
            },
            {
              media: "(min-width: 768px)",
              sizes: "100vw",
              srcSet: `
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/whats-new-for-her/desktop.jpg 590w,
                ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-her/whats-new-for-her/desktop_2x.jpg 1180w
              `,
            },
          ]}
        />
      </LinkBlock>
      <SectionTextBlock>
        <SectionTitle>What&apos;s New For Her</SectionTitle>
        <SectionDescription>Shop the latest styles for her.</SectionDescription>
        <SectionLink data-lc="best-sellers" to="/new-items-for-her">
          Shop Now
        </SectionLink>
      </SectionTextBlock>
    </Block>
  </Flex>
)

export default BestSellers
